import { render, staticRenderFns } from "./ModalEditMember.vue?vue&type=template&id=298058bc&"
import script from "./ModalEditMember.vue?vue&type=script&lang=js&"
export * from "./ModalEditMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports